import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const activepieces = defineConnector({
  identifier: "activepieces",
  name: "Activepieces",
  tagLine: "Open source automation platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://cloud\\.activepieces\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Enter your Activepieces instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "cloud.activepieces.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Activepieces, go to **Settings › API Keys** and create a new key. See the [API docs](https://www.activepieces.com/docs/developers/overview) for details.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v1/projects`,
  },
});
